import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function changeAssetIndex({ coinId, stockRuId, index }) {
  const param = coinId ? `coin_id=${coinId}` : `stock_ru_id=${stockRuId}`;
  const url = `${backendUrl}/api/widgets/user-assets/?${param}&new_index=${index}`;
  try {
    const response = await fetchWithAuth(url, { method: 'PATCH' });
    if (!response.ok) {
      throw new Error(`Network error: HTTP ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error changing asset index:', error);
    throw error;
  }
}
